import type { TFunction } from 'i18next';

export const getInputPlaceholder = (t: TFunction) =>
  t(`Items may be entered as either comma, semicolon, or new line separated values.

  Examples:
  Example1,Example2
  or
  Example1;Example2
  or
  Example1
  Example2`);
